// Keeps search titles and descriptions inside the lengths Google shows in full
// (titles ~60 characters, descriptions ~155), trimming at natural break points.

const BRAND = "Coastside Law";
const TITLE_MAX = 60;
const DESC_MAX = 155;

function wordCut(text: string, max: number): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max + 1);
  const i = cut.lastIndexOf(" ");
  let out = i > max * 0.6 ? cut.slice(0, i) : text.slice(0, max);
  // Don't end on a dangling joining word ("for", "and", "&" ...).
  for (let n = 0; n < 3; n++) {
    out = out.replace(/[\s,;:—–|&-]+$/, "").replace(/\s+(for|and|or|of|in|to|the|a|an|with|&)$/i, "");
  }
  return out.replace(/[\s,;:—–|&-]+$/, "");
}

export function fitTitle(title: string): string {
  if (!title || title.length <= TITLE_MAX) return title;
  const base = title.replace(/\s*[|—–-]\s*Coastside Law\s*$/i, "").trim();
  const withBrand = `${base} | ${BRAND}`;
  if (withBrand.length <= TITLE_MAX) return withBrand;
  if (base.length <= TITLE_MAX) return base;
  for (const sep of [" — ", " – ", " | ", ": ", " (", " - "]) {
    const first = (base.split(sep)[0] ?? "").trim();
    if (first !== base && first.length >= 20) {
      const branded = `${first} | ${BRAND}`;
      return branded.length <= TITLE_MAX ? branded : fitTitle(first);
    }
  }
  return wordCut(base, TITLE_MAX);
}

export function fitDescription(desc: string): string {
  if (!desc || desc.length <= DESC_MAX) return desc;
  // Split into sentences, ignoring abbreviations like "incl." and "e.g.".
  const safe = desc.replace(/\b(incl|e\.g|i\.e|approx|St|No)\./g, "$1\u0000");
  const sentences = (safe.match(/[^.!?]+[.!?]+(\s|$)/g) ?? []).map((x) => x.replace(/\u0000/g, "."));
  let out = "";
  for (const s of sentences) {
    if ((out + s).trim().length > DESC_MAX) break;
    out += s;
  }
  out = out.trim();
  if (out.length >= 90) return out;
  return `${wordCut(desc, DESC_MAX - 1)}…`;
}
